import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import Context from '../context2.0';
import classNames from 'classnames';

class TopicContent extends Component {


    render() {
        const {className, content } = this.props;
        const contentCls = classNames("large-audio-item", className);

        if (content) {
            let { script, audio } = content;
            return (
                <>
                    <Context className={contentCls} audio={audio} script={script} />
                </>

            )
        } else {
            return (
                null
            )
        }

    }
}


TopicContent.propTypes = {
    content: PropTypes.object.isRequired,
};


export default TopicContent;